import React, { useEffect, useState } from "react";
import { clearSenstiveDataFromLocalStorage } from "@/taskpane/utils/storage";

export default function Logo({ height = '48px' }) {
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    if (counter >= 5) {
      clearSenstiveDataFromLocalStorage();
      window.location.reload();
    }
  }, [counter]);

  return <img src="/assets/logo-genapi-actes-rgb-horiz-orange-blue.svg" height={height} onClick={() => setCounter(counter + 1)} />;
}
